module.exports = __webpack_public_path__ + "static/media/CT_2019_30442A_pdf.7ce69e4e.pdf";